<template>
  <b-container style="width:50%">
    <p>Enter the code you received below along with your new password.</p>
    <p>Do not navigate from this page or else you will need to request a new verification code! {{parentUsername}}</p>
    <b-row>
      <b-col class="text-center">
        <b-alert variant="warning" :show="inError" style="display:inline-block;">
          {{ submitPasswordErrorMessage }}
        </b-alert>
      </b-col>
    </b-row>
    <validation-observer ref="observer" v-slot="{ invalid }" tag="form">
      <b-form @submit="onSubmit">
        <b-row>
          <b-col>
            <b-form-group id="verificationCodeGroup" label='Verification Code' label-for="codeInput">
              <b-form-input id="codeInput" type="text" required v-model="form.verifyCode"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <validation-provider name="password"
                                 :rules="{required: true, regex: /^(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).+$/ }"
                                 vid="pass" v-slot="{ errors }">
              <b-form-group id="passwordGroup" label="Password:" label-for="passInput">
                <b-input-group>
                  <b-input id="passInput" type="password" v-model="form.pass"/>
                  <b-input-group-append><a href="#" id="passwordInfo"><img src="../assets/question.png"
                                                                           alt="password question mark"/></a>
                  </b-input-group-append>
                </b-input-group>
                <span class="text-danger">{{errors[0]}}</span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider name="password confirmation" rules="required|passwordConfirm:pass"
                                 v-slot="{ errors }">
              <b-form-group id="passwordConfirmGroup" label="Confirm Password:" label-for="confirmInput">
                <b-input id="confirmInput" type="password" v-model="form.confirmPass"/>
                <span class="text-danger">{{errors[0]}}</span>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button type="submit" variant="outline-danger">Submit</b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <b-popover target="passwordInfo" triggers="hover" variant="danger">
      <template v-slot:title>Password Requirements</template>
      <ul>
        <li>At least 1 lower case and 1 upper case letter</li>
        <li>At least 1 digit</li>
        <li>At least 1 of the following special characters<br/>!@#$%^&*</li>
        <li>Minimum length of 10 characters</li>
      </ul>
    </b-popover>

    <b-modal id="successModal"
             ref="successModal"
             hide-header
             ok-only
             body-bg-variant="dark"
             body-class="default-color"
             ok-variant="outline-danger"
             footer-bg-variant="dark"
             @ok="doRedirect"
    >
      <p>Password updated successfully.</p>
    </b-modal>
  </b-container>
</template>

<script>
  import { Auth } from 'aws-amplify'

  export default {
    name: 'ResetPasswordSubmit',
    props: ['parentUsername'],
    data () {
      return {
        inError: false,
        submitPasswordErrorMessage: '',
        form: {
          verifyCode: '',
          pass: ''
        }
      }
    },
    methods: {
      onSubmit (e) {
        e.preventDefault()
        this.inError = false
        this.$refs.observer.validate().then((result) => {
          if (!result) {
            return
          }
          Auth.forgotPasswordSubmit(this.parentUsername, this.form.verifyCode, this.form.pass).then(() => {
            this.$refs['successModal'].show()
          }).catch(err => {
            this.submitPasswordErrorMessage = err.message
            this.inError = true
          })
        })
      },
      doRedirect () {
        this.$router.push({ name: 'home' })
      }
    }
  }
</script>
